<template>
    <div>
        <div class="flex-row justify-between align-center">
                    <div>
                        <div class="title">&nbsp;&nbsp;标题</div>
                        <div>&nbsp;&nbsp;&nbsp;&nbsp;{{ articleTitle }}</div>
                    </div>
        </div>
        
        <div class="flex-row justify-between align-center">
              <div>
                  <div class="title">&nbsp;&nbsp;内容</div>
                  <div>&nbsp;&nbsp;&nbsp;&nbsp;{{ articleContent }}</div>
              </div>    
        </div>
        <div id="swiper" class="container-fuild" v-if="articleFilesImg!=null&&articleFilesImg.length>0">
          <div class="swiper-container banner-swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in articleFilesImg" :key="index">
                <img class="swiper-lazy" :src="item.fileName" style="width: 100%;">
                <div class="swiper-lazy-preloader"></div>
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination"></div>
          </div>
        </div>


      

 
      <div class="video" v-if="articleFilesVideo.fileName!=''">
                  <video :src="articleFilesVideo.fileName" controls  style="width: 100%; height: auto;"></video>
              </div>
      </div>
</template>

<script>

import Swiper from "swiper";
// import { controllerData,  meterData} from "../products/products";
export default {
    data() {
        return {
            //testText:" FJ-G1系列产品为交流感应电机控制器，采用先进的控制算法，有效提高电动车辆的可操作性和舒适性并可借助FJ运程监控系统(选搭配FJ-M1仪表)，实现电动车辆的远程管理、报警预警、参数查询与修改、运行数据分析等车联网功能，同时配备蓝牙、4G功能要加便于调试及远程控制。",
            // tableData: [{
            //    name1: '32-60V ',
            //    name2: '400A ',
            //    name3: '-40C-50℃  ',
            //    name4: '-40C-85℃',
            //    name5: '85℃',
            //    name6: '<85%',
            //    name7: 'IP67',
            //}, {
            //    name1: '32-60V ',
            //    name2: '400A ',
            //    name3: '-40C-50℃  ',
            //    name4: '-40C-85℃',
            //    name5: '85℃',
            //    name6: '<85%',
            //    name7: 'IP67',
            //}],
            //tableData1: [{
            //    name1: 'FJ-D1-24-S  ',
            //    name2: '24',
            //    name3: '250/300/350',
            //    name4: '125/150/175',
            //    name5: 'S',
            //}, {
            //    name1: 'FJ-D1-24-S  ',
            //    name2: '24',
            //    name3: '250/300/350',
            //    name4: '125/150/175',
            //    name5: 'S',
            //}],
            articleTitle:"",
            articleContent:"",
            articleFilesImg:[{"fileName":""}],
            articleFilesVideo:{"fileName":""}
        }
    },
    methods: {
        
    },
    mounted() {
         /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: 'fade',
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });


        debugger
        let id =  this.$route.query.id;
        let that=this;
        this.$emit("hideHead");
        debugger
        this.http.getOther("http://fanji.nxm.fjctrlwdt.com/prod-api/home/article/detail/"+id,{}).then((result)=>{
            debugger
            console.log(JSON.stringify(result));
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==200){
            that.articleFilesImg=[];
            that.articleFilesVideo.fileName="";
            that.articleTitle=objResult.data.articleTitle;
            that.articleContent=objResult.data.articleContent;
            let articleFiles= objResult.data.articleFiles;
            articleFiles.forEach(element => {
                if(element.fileName.endsWith(".mp4")||element.fileName.endsWith(".MP4")){
                    that.articleFilesVideo.fileName=element.fileName; 
                }
                else{
                    that.articleFilesImg.push({"fileName":element.fileName});
                }      
             });
             debugger
            }
        });


        
    }
}
</script>

<style scoped>
.video {
    /* background-color: #00585252;
    height: 200px; */
    width: 100%;
}

.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}

.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}


/* 轮播图 */
/* #swiper { */
    /* height: 600px; */
/* } */
#swiper .banner-swiper {
  width: 100%;
  /* height: 100%; */
}
#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  /* height: 100%; */
  text-align: center;
  /* margin-left: 10%; */
  
}
#swiper .banner-swiper .swiper-slide{
  position: relative;
}
#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background:#0AA00A ;
  /* background: rgba(51, 51, 51, 0.534); */
  text-align: center;
  line-height: 80px;
}
#swiper .banner-swiper .swiper-slide-title > h1{
  font-size: 50px;
  margin-top: 12%;
}
#swiper .banner-swiper .swiper-slide-title > p{
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}


#swiper .swiper-button-prev  {
    color:#0AA00A ;
}

#swiper  .swiper-button-next {
    color:#0AA00A ;
}

#swiper .swiper-pagination{
    color:#0AA00A ;
}

</style>


// WEBPACK FOOTER //
// src/views/community/m_share.vue